<template>
  <div class="team-container container-fluid py-4 px-5">
    <div class="text-center mb-4">
      <h1 class="title-page mb-1">Team Culture</h1>
      <p class="sub-title">Building Great Things Together</p>
    </div>

    <div class="culture-card" v-if="teamCultureData && teamCultureData.length > 0">
      <template v-for="(section, index) in teamCultureData">
        <div :key="index" v-if="shouldShowSection(section)">
        
          <!-- Header / Banner -->
          <div v-if="section.type === 'banner'" class="header-banner rounded-lg p-4 mb-4 d-flex justify-content-between align-items-center text-white">
            <div>
              <h1 class="font-weight-bold mb-3">
                {{ section.content.greeting }}
              </h1>
              <h5 class="mb-0 opacity-75 description">
                {{ section.content.subtext }}
              </h5>
            </div>
            <i data-feather="sun" class="header-icon"></i>
          </div>

          <!-- team_shoutout -->
          <div v-if="section.type === 'team_shoutout'" class="row bg-success p-3 rounded-lg text-white text-align-center height-150">
              <!-- <ul class="bg-success list-group list-group-flush"> -->
                  <!-- <li v-for="(item, i) in section.content.items" :key="i" class="list-group-item bg-success d-flex justify-content-between align-items-center border-0 px-0"> -->
                      <i style="margin-top: 30px; " data-feather="award" class="mr-3 shoutout-icon"></i>
                      <h2 style="margin-top: 40px;">{{ section.content.items[0].label }}</h2>
                  <!-- </li> -->
              <!-- </ul> -->
          </div>


          <!-- Values -->
          <div v-if="section.type === 'values'" class="info-box p-4 rounded-lg mb-4">
            <div class="section-title mb-4">
              <i data-feather="heart" class="mr-2"></i>
              {{ section.content.title }}
            </div>

            <div class="row">
              <div
                v-for="(value, vIndex) in section.content.items"
                :key="vIndex"
                class="col-6 col-md-3 mb-3"
              >
                <div class="value-card text-center p-2 rounded-lg h-100">
                  <!-- Placeholder icon logic, assuming backend doesn't send icon name yet or uses a default -->
                  <i data-feather="star" class="value-icon mb-3"></i> 
                  <h3 class="font-weight-bold">{{ value.title }}</h3>
                  <h6 class=" text-muted ">{{ value.description }}</h6>
                </div>
              </div>
            </div>
          </div>

          <!-- Shoutout -->
          <!-- <div v-if="section.type === 'shoutout'" class="shoutout-banner rounded-lg p-4 d-flex align-items-center text-white mb-4">
            <i data-feather="thumbs-up" class="shoutout-icon mr-4"></i>
            <div>
              <h2 class="font-weight-bold mb-2">{{ section.content.title }}</h2>
              <p class="mb-0 description">{{ section.content.description }}</p>
            </div>
          </div> -->

        </div>
      </template>
      
    </div>
    <div v-else-if="teamCultureData && teamCultureData.length === 0" class="text-center py-5">
        <div class="bg-white rounded-lg shadow-sm p-5 text-muted mx-auto" style="max-width: 400px;">
            <i data-feather="inbox" class="mx-auto mb-3" style="width: 48px; height: 48px; opacity: 0.5;"></i>
            <h4 class="font-weight-bold mb-2">No Team Culture Updates</h4>
            <p class="mb-0">Check back later for shoutouts, values, and updates.</p>
        </div>
    </div>
     <div v-else class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
  </div>
</template>


<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import feather from 'feather-icons'
import axios from 'axios'
import moment from 'moment' // Import moment.js

const teamCultureData = ref(null)

const fetchTeamCulture = async () => {
    try {
        const response = await axios.get('/app/public-dashboard/team-culture')
        teamCultureData.value = response.data
        
        nextTick(() => {
            feather.replace()
        })
    } catch (error) {
        console.error("Failed to fetch team culture data:", error)
        teamCultureData.value = []; // Set to empty array on error to stop loading indicator
    }
}

// Function to check if a section should be shown based on time settings
const shouldShowSection = (section) => {
    if (!section.settings || !section.settings.show_by_time) {
        return true; // If show_by_time is false or not set, always show
    }

    const currentTime = moment();
    const startTime = moment(section.settings.start_time, 'HH:mm');
    const endTime = moment(section.settings.end_time, 'HH:mm');

    // Handle sections spanning midnight (e.g., 17:00 - 00:00)
    if (endTime.isBefore(startTime)) {
        // If current time is after start time (same day) OR current time is before end time (next day, treated as part of the interval)
        return currentTime.isSameOrAfter(startTime, 'minute') || currentTime.isBefore(endTime, 'minute');
    } else {
        // Standard case: start time before end time (same day)
        return currentTime.isSameOrAfter(startTime, 'minute') && currentTime.isBefore(endTime, 'minute');
    }
};


let timerInterval = null;

onMounted(() => {
    fetchTeamCulture()
    timerInterval = setInterval(fetchTeamCulture, 60 * 1000);
})

onBeforeUnmount(() => {
    if (timerInterval) clearInterval(timerInterval)
})
</script>

<style scoped>
/* ================= BASE ================= */
.team-container {
  overflow: hidden;
}

.header-banner {
  background-color: #a32a31;
}

.header-banner div h1 {
  font-size: 2rem;
}

.header-banner div .description {
  font-size: 1rem;
}

.header-icon svg {
  width: 50px;
  height: 50px;
  opacity: 0.25;
}


/* New Styles */
.title-page {
    font-size: 1.6rem; /* text-5xl */
    line-height: 1; 
    font-weight: 1000; /* font-bold */
    color: rgb(17, 24, 39); /* text-gray-900 */
    letter-spacing: -0.025em; /* tracking-tight */
} 
.sub-title {
    font-size: 1rem; /* text-2xl (24px) */
    line-height: 2rem; 
    color: rgb(107, 114, 128); /* text-gray-500 */
}
.section-title {
    font-size: 1.875rem;                                                                                                                                
    line-height: 2.25rem; 
    font-weight: 700;
    display: flex;
    align-items: center;
}

.section-title svg {
  width: 24px;
  height: 24px;
}

.value-card {
  background: #f8f9fa;
  transition: 0.3s ease;
}

.value-card h3 {
  font-size: 1.5rem;
}

.value-card h6 {
  font-size: 1rem;
}

.value-card:hover {
  background: #ffffff;
  box-shadow: 0 6px 16px rgba(0,0,0,0.08);
  transform: translateY(-4px);
}

.value-icon {
  width: 50px !important;
  height: 60px !important;
  color: #a32a31;
}

.shoutout-banner {
  background-color: #388e3c;
}

.shoutout-icon {
  width: 60px;
  height: 55px;
}


/* ================= RESPONSIVE ================= */

/* ≤ 1200px */
@media (max-width: 1200px) {
  .team-container {
    padding-left: 24px;
    padding-right: 24px;
  }
}

/* ≤ 992px (Tablet) */
@media (max-width: 992px) {
  .header-banner {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }

  .header-icon svg {
    width: 36px;
    height: 36px;
  }
}

/* ≤ 768px (Mobile Landscape) */
@media (max-width: 768px) {
  .section-title {
    font-size: 1.5rem !important;
  }

  .value-card {
    padding: 20px;
  }

  .shoutout-banner {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }

  .shoutout-icon {
    margin-right: 0;
  }
}

/* ≤ 576px (Mobile Portrait) */
@media (max-width: 576px) {
  .team-container {
    padding-left:1rem !important;
    padding-right:1rem !important;
  }

  .header-banner div h1 {
    font-size: 1.8rem !important;
  }

  .header-banner div p {
    font-size: 1.4rem !important;
  }

  .section-title {
    font-size: 1.2rem !important;
  }

  .value-icon {
    width: 24px;
    height: 24px;
  }

  .shoutout-banner div h3 {
    font-size: 1.2rem !important;
  }
}
</style>
